import styled from '@emotion/styled';
import { layout, space, position, system } from 'styled-system';
import shouldForwardProp from '@styled-system/should-forward-prop';

const props = system({
    visibility: true,
});

export const Span = styled('span', {
    shouldForwardProp,
})(layout, space, position, props);
